import { PAGE_KEYS } from "./pageKeys";

const ROUTE_RULES = [
  { test: (p) => /^\/accounts\/register(\/|$)/.test(p), pageKey: PAGE_KEYS.REGISTER_MAIN },
  { test: (p) => /^\/accounts\/login(\/|$)/.test(p), pageKey: PAGE_KEYS.LOGIN_MAIN },
  { test: (p) => /^\/accounts\/country(\/|$)/.test(p), pageKey: PAGE_KEYS.REGISTER_MAIN },
  { test: (p) => /\/wallet\/deposit/.test(p), pageKey: PAGE_KEYS.DEPOSIT_CRYPTO },
  { test: (p) => /\/wallet\/withdraw/.test(p), pageKey: PAGE_KEYS.WITHDRAW_CRYPTO },
  { test: (p) => /^\/accounts\/assets\/wallet(\/|$)/.test(p), pageKey: PAGE_KEYS.WALLET },
  { test: (p) => /^\/accounts\/user(\/|$)/.test(p), pageKey: PAGE_KEYS.KYC_MAIN },
];

function normalizePath(path) {
  if (!path) return "";
  const withoutQuery = String(path).split("?")[0].split("#")[0];
  const stripped = withoutQuery.replace(/^\/[a-z]{2}(-[A-Z]{2})?(?=\/|$)/i, "");
  return stripped || "/";
}

export function resolvePageKeyFromPath(path) {
  const normalized = normalizePath(path);
  for (const rule of ROUTE_RULES) {
    if (rule.test(normalized)) return rule.pageKey;
  }
  return null;
}

export default resolvePageKeyFromPath;
